const units = [
    {
        campaign: 'hbomax',
        category: 'hbomax',
        name: 'hbomax-unit',
        country: ['US'],
        heading: 'Where HBO Meets So Much More',
        subheading: 'START YOUR FREE TRIAL',
        link: 'https://www.hbomax.com/',
        image: 'https://static.wikia.nocookie.net/05a5bbb9-7662-416e-99c7-6e6700af9aa3',
        extraDisclaimer: 'Free trial for new customers only. Restrictions Apply.',
    },
    {
        campaign: 'pathfinder',
        category: 'bingebit',
        name: 'pathfinder-bingebit',
        country: ['US', 'GB'],
        heading: 'Tell us which TV shows you like',
        subheading: 'Recommendations just for you!',
        link: 'https://bingebot.fandom.com/?icid_source=fandom&icid_medium=in-wiki&icid_campaign=default-bingebit',
        image: 'https://static.wikia.nocookie.net/16b2e528-994f-4fb2-8649-cfeb0f3e62a3',
    },
    {
        campaign: 'fanatical',
        category: 'fanatical',
        name: 'fanatical-unit',
        country: ['US'],
        heading: 'Incredible PC game bundle, from $10',
        subheading: 'Buy from Fanatical',
        link: 'https://www.fanatical.com/en/pick-and-mix/platinum-collection-build-your-own-bundle?utm_source=fandom&utm_medium=partner&utm_campaign=platinum_collection_june&utm_content=platinum_june',
        image: 'https://static.wikia.nocookie.net/c0786335-1ae8-4cf0-b278-811bb2a68fcc',
        logo: {
            light: 'https://static.wikia.nocookie.net/dc786282-6077-4a40-a684-2b278df7b82d',
            dark: 'https://static.wikia.nocookie.net/58005ce6-2fdd-4c22-991c-6b1b4a8556c1',
        },
        mobileLogo: {
            light: 'https://static.wikia.nocookie.net/d7918d3f-66d4-4960-b2a5-50bbb1c16ade',
            dark: 'https://static.wikia.nocookie.net/29bb0905-b53e-4e4a-b25b-90bfa8ec6f12',
        },
    },
    {
        campaign: 'ddb',
        category: 'ddb',
        name: 'ddb-unit',
        heading: 'Get everything you need to play D&D today',
        subheading: 'Begin Your Adventure',
        link: 'https://www.dndbeyond.com/intro',
        image: 'https://static.wikia.nocookie.net/f5b6c309-5ab5-44d7-bcec-d585f3816946',
        logo: {
            light: 'https://static.wikia.nocookie.net/4d047095-f895-4efa-a644-4ed093db5dd9',
            dark: 'https://static.wikia.nocookie.net/328f8cb8-ee40-4764-9f26-35402d3c62f0',
        },
    },
    {
        campaign: 'disneyplus',
        category: 'disney',
        name: 'disney-unit',
        country: ['NO'],
        heading: 'Introduksjonstilbud. 1 år | 590 kr',
        subheading: 'Forhåndsbestill nå',
        link: 'https://disneyplus.bn5x.net/c/1947570/871867/9358?subId1=generic_NO&subId2=nordic_presale&subId3=banner-fandom_5brands&sharedId=wiki_desktop',
        image: 'https://static.wikia.nocookie.net/df3afc30-0f94-470d-85ce-e1319062c993',
    },
    {
        campaign: 'disneyplus',
        category: 'disney',
        name: 'disney-unit',
        country: ['FI'],
        heading: 'Aloitustarjous. 1 vuosi | €59.99',
        subheading: 'Ennakkotilaa nyt',
        link: 'https://disneyplus.bn5x.net/c/1947570/871867/9358?subId1=generic_FI&subId2=nordic_presale&subId3=banner-fandom_5brands&sharedId=wiki_desktop',
        image: 'https://static.wikia.nocookie.net/df3afc30-0f94-470d-85ce-e1319062c993',
    },
    {
        campaign: 'disneyplus',
        category: 'disney',
        name: 'disney-unit',
        country: ['DK'],
        heading: 'Introduktionstilbud. 1 år | 490 kr',
        subheading: 'Forudbestil nu',
        link: 'https://disneyplus.bn5x.net/c/1947570/871867/9358?subId1=generic_DK&subId2=nordic_presale&subId3=banner-fandom_5brands&sharedId=wiki_desktop',
        image: 'https://static.wikia.nocookie.net/df3afc30-0f94-470d-85ce-e1319062c993',
    },
    {
        campaign: 'disneyplus',
        category: 'disney',
        name: 'disney-unit',
        country: ['SE'],
        heading: 'Introduktionserbjudande. 1 år | 590 kr',
        subheading: 'Förbeställ nu',
        link: 'https://disneyplus.bn5x.net/c/1947570/871867/9358?subId1=generic_SE&subId2=nordic_presale&subId3=banner-fandom_5brands&sharedId=wiki_desktop',
        image: 'https://static.wikia.nocookie.net/df3afc30-0f94-470d-85ce-e1319062c993',
    },
    {
        campaign: 'disneyplus',
        category: 'disney',
        name: 'disney-unit',
        country: ['BE'],
        heading: 'Nur für kurze zeit. Frühbucherrabatt sichern.',
        subheading: 'Jetzt vorbestellen',
        link: 'https://disneyplus.bn5x.net/c/1947570/871867/9358?subId1=generic_BE&subId2=nordic_presale&subId3=banner-fandom_5brands&sharedId=wiki_desktop',
        image: 'https://static.wikia.nocookie.net/df3afc30-0f94-470d-85ce-e1319062c993',
    },
    {
        campaign: 'disneyplus',
        category: 'disney',
        name: 'disney-unit',
        country: ['PT'],
        heading: 'Operta de pré-lançamento. 1 ano | 59,99€*',
        subheading: 'Subscreva já',
        link: 'https://disneyplus.bn5x.net/c/1947570/871867/9358?subId1=generic_PT&subId2=nordic_presale&subId3=banner-fandom_5brands&sharedId=wiki_desktop',
        image: 'https://static.wikia.nocookie.net/df3afc30-0f94-470d-85ce-e1319062c993',
    },
    {
        campaign: 'disneyplus',
        category: 'disney',
        name: 'disney-unit',
        country: ['BR'],
        heading: 'Economize dinheiro na Disney+ na pré-venda antes do lançamento oficial em 17 de Novembro.',
        subheading: 'Assine agora mesmo.',
        link: 'https://disneyplus.bn5x.net/c/1947570/918026/9358?subId1=generic_BR&subId2=latam_presale&subId3=banner-fandom&sharedId=wiki_desktop',
        image: 'https://static.wikia.nocookie.net/df3afc30-0f94-470d-85ce-e1319062c993',
    },
    {
        campaign: 'disneyplus',
        category: 'disney',
        name: 'disney-unit',
        country: ['AR'],
        heading: 'Ahorra dinero con la preventa de Disney+ antes del lanzamiento oficial el 17 de Noviembre.',
        subheading: 'Suscríbete ahora.',
        link: 'https://disneyplus.bn5x.net/c/1947570/918026/9358?subId1=generic_AR&subId2=latam_presale&subId3=banner-fandom&sharedId=wiki_desktop',
        image: 'https://static.wikia.nocookie.net/df3afc30-0f94-470d-85ce-e1319062c993',
    },
    {
        campaign: 'disneyplus',
        category: 'disney',
        name: 'disney-unit',
        country: ['CL'],
        heading: 'Ahorra dinero con la preventa de Disney+ antes del lanzamiento oficial el 17 de Noviembre.',
        subheading: 'Suscríbete ahora.',
        link: 'https://disneyplus.bn5x.net/c/1947570/918026/9358?subId1=generic_CL&subId2=latam_presale&subId3=banner-fandom&sharedId=wiki_desktop',
        image: 'https://static.wikia.nocookie.net/df3afc30-0f94-470d-85ce-e1319062c993',
    },
    {
        campaign: 'disneyplus',
        category: 'disney',
        name: 'disney-unit',
        country: ['CO'],
        heading: 'Ahorra dinero con la preventa de Disney+ antes del lanzamiento oficial el 17 de Noviembre.',
        subheading: 'Suscríbete ahora.',
        link: 'https://disneyplus.bn5x.net/c/1947570/918026/9358?subId1=generic_CO&subId2=latam_presale&subId3=banner-fandom&sharedId=wiki_desktop',
        image: 'https://static.wikia.nocookie.net/df3afc30-0f94-470d-85ce-e1319062c993',
    },
    {
        campaign: 'disneyplus',
        category: 'disney',
        name: 'disney-unit',
        country: ['MX'],
        heading: 'Ahorra dinero con la preventa de Disney+ antes del lanzamiento oficial el 17 de Noviembre.',
        subheading: 'Suscríbete ahora.',
        link: 'https://disneyplus.bn5x.net/c/1947570/918026/9358?subId1=generic_MX&subId2=latam_presale&subId3=banner-fandom&sharedId=wiki_desktop',
        image: 'https://static.wikia.nocookie.net/df3afc30-0f94-470d-85ce-e1319062c993',
    },
    {
        campaign: 'disneyplus',
        category: 'disney',
        name: 'disney-unit',
        country: ['PE'],
        heading: 'Ahorra dinero con la preventa de Disney+ antes del lanzamiento oficial el 17 de Noviembre.',
        subheading: 'Suscríbete ahora.',
        link: 'https://disneyplus.bn5x.net/c/1947570/918026/9358?subId1=generic_PE&subId2=latam_presale&subId3=banner-fandom&sharedId=wiki_desktop',
        image: 'https://static.wikia.nocookie.net/df3afc30-0f94-470d-85ce-e1319062c993',
    },
];
export default units;
